import React, {Component} from 'react';
import Slideshow from '../Slideshow/Slideshow'
import ExpandableText from '../ExpandableText/ExpandableText'
import './Overlay.css';
import {Link} from 'react-router';
import Callback from "../Callback/Callback";

class Overlay extends Component {

    constructor(props) {
        super(props);
        this.state = {
            idx: -1,
            type: 'default',
            intervalId: -1,
            speed: 2,
            targetY: 0,
            navVisible: true
        };

        this.scrollCount = 0;
        this.toggleBtn = {};

        this.isVisible = false;

    }


    static propTypes = {
        value: React.PropTypes.object,
        panels: React.PropTypes.array,
        onClose: React.PropTypes.func
    }

    toTop = (event) => {
        //console.log((" - this._top: " + this._top);
        //this._innerDiv.scrollTop = 0;
        this.slideTo(0);
    }

    toPage = (diffFromEnd) => {
        //console.log(("TO PAGE - diffFromEnd: " + diffFromEnd + " ABS: " + (this.props.value.rooms.length + this.props.value.articles.length));
        this.setState({
            idx: this.props.value.rooms.length + this.props.value.articles.length + diffFromEnd,
            type: 'default'
        });
        //this.toContent();
    }

    slideTo = (value) => {
        this.stopScroll();
        this.setState({targetY: value});

        var intervalId = setInterval(this.scrollTo, 100);
        this.setState({intervalId: intervalId});

    }

    scrollTo = () => {
        var step = (this.state.targetY - this._innerDiv.scrollTop) / this.state.speed;

        if (Math.abs(Math.floor(step)) <= 2 || this.scrollCount++ > 5) {
            this._innerDiv.scrollTop = this.state.targetY;
            this.stopScroll();
            //console.log((" - scroll complete: " + this._innerDiv.scrollTop);
        } else {
            this._innerDiv.scrollTop += step;
        }

    }

    stopScroll = () => {
        clearInterval(this.state.intervalId);
        this.scrollCount = 0;
        this.setState({intervalId: -1});
    }

    handleClose = () => {

        if (typeof this.props.onClose === 'function') {
            //this.props.onClose();
        }

        setTimeout(function () {
            this.setState({navVisible: true});
            this._innerDiv.scrollTop = 0;

        }.bind(this), 500);

    }


    clickArticleHandler = (idx, e) => {
        this.setState({idx: idx, type: 'default'});
        //this.toContent();
    }

    clickRoomHandler = (idx, e) => {
        this.setState({idx: idx, type: 'room'});
        //this.toContent();
    }

    componentDidMount() {
        ////console.log(("componentDidMount: " + this.props.value.idx);
        window.addEventListener("resize", this.updateDimensions);
    }


    componentWillUnmount() {
        this.stopScroll();
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions = () => {
        this.setState({navVisible: true});
    }


    toggleNav = (e) => {
        e.preventDefault();
        //console.log(("toggleNav - this.state.navVisible: " + this.state.navVisible);
        this.setState({navVisible: !this.state.navVisible});
    }

    onNavClick = (e) => {
        this._innerDiv.scrollTop = 0;
        if (this.toggleBtn.offsetParent !== null) {
            this.setState({navVisible: false});
        }
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.value.idx !== this.state.idx) {
            this.setState({idx: nextProps.value.idx, type: nextProps.value.type});
        }

        if (this.props.value.isVisible && !this.isVisible) {
            this.isVisible = true;
        } else if (!this.props.value.isVisible && this.isVisible) {
            this.isVisible = false;
        }
    }


    render() {

        let callbackUrl = "";
        if (process.env.NODE_ENV !== "production") {
            callbackUrl = "https://landhotel-schorssow.de/php/callback.php";
        } else {
            callbackUrl = "https://landhotel-schorssow.de/php/callback.php";
        }

        if (this.props.value.isVisible === null) {
            return null;
        }

        /*    if (this.props.value.isVisiletble === null || !this.props.value.isVisible) {
                return null;
            }*/


        var visibleClass = "";
        if (this.props.value.isVisible) {
            visibleClass = "FadeIn";
        } else if (!this.props.value.isVisible) {
            visibleClass = "FadeOut";
        }


        let navButtons = [];
        let headline = "";
        let text = "";
        let images = [];
        let bookingUrl = "";
        var i, btnText, cl;
        var idx = 0;

        var backId = "/";


        // ROOMS


        var showAusstattung = false;
        var showInfos = false;
        var showHinweise = false;


        if (this.props.value.rooms !== undefined) {
            ////console.log(("Overlay - this.props.value.rooms.length: " + this.props.value.rooms.length);

            images = [];
            for (i = 0; i < this.props.value.rooms.length; i++) {
                var room = this.props.value.rooms[i];

                btnText = room.headline;

                cl = "";

                //let oc = this.toPage.bind(this,'hinweise');

                ////console.log(("Overlay - idx.toString() === this.state.idx: " + idx.toString() + " // " + this.props.value.idx);

                if (idx.toString() === this.props.value.idx.toString()) {
                    headline = this.props.value.rooms[i].headline;
                    ////console.log(("Overlay - show head active: " + headline);
                    text = this.props.value.rooms[i].text;
                    images = room.images;

                    bookingUrl = room.booking_url;

                    showAusstattung = this.props.value.rooms[i].show_ausstattung;
                    showInfos = this.props.value.rooms[i].show_infos;
                    showHinweise = this.props.value.rooms[i].show_hinweise;

                    cl = "Button-Active";
                } else {
                    cl = "Button";
                }

                //let boundItemClick = this.clickRoomHandler.bind(this, idx);

                //navButtons.push(<div className={cl} key={idx.toString()} onClick={boundItemClick}><span>{btnText}</span></div>);
                navButtons.push(<Link onClick={this.onNavClick} className={"SubNavButton " + cl}
                                      to={"/" + this.props.value.type + "/" + idx.toString()}
                                      key={idx.toString()}><span>{btnText}</span></Link>);

                idx++;
            }
        }

        var appartmentOffset = 0;
        if (this.props.value.rooms !== undefined) {
            appartmentOffset = this.props.value.rooms.length;
        }

        ////console.log(("Overlay - appartmentOffset: " + appartmentOffset + " TAR: " + this.props.value.idx);

        // ARTICLES / PAGES
        if (this.props.value.articles !== undefined) {

            for (i = 0; i < this.props.value.articles.length; i++) {
                btnText = this.props.value.articles[i].headline;

                this.props.value.articles[i].idx = i;
                this.props.value.articles[i].type = this.props.value.type;

                cl = "";

                if ((i).toString() === (this.props.value.idx - appartmentOffset).toString()) {
                    headline = this.props.value.articles[i].headline;
                    text = this.props.value.articles[i].text;
                    cl = "Button-Active";

                    showAusstattung = this.props.value.articles[i].show_ausstattung;
                    showInfos = this.props.value.articles[i].show_infos;
                    showHinweise = this.props.value.articles[i].show_hinweise;

                } else {
                    cl = "Button";
                }

                //let boundItemClick = this.clickArticleHandler.bind(this, idx);

                navButtons.push(<Link onClick={this.onNavClick} className={"SubNavButton " + cl}
                                      to={"/" + this.props.value.type + "/" + idx}
                                      key={idx.toString()}><span>{btnText}</span></Link>);
                idx++;
            }
        }


        var expPanels = [];
        if (this.props.value.panels) {
            expPanels = this.props.value.panels;

        }
        var textExpanded = false;

        var imgUrl = "";
        if (this.props.value.image !== null && this.props.value.image !== undefined) {
            imgUrl = this.props.value.image.url;
        }

        return (
            <div id="overlay" className={"Overlay " + visibleClass}>

                <div className="Content" style={{backgroundImage: 'url(' + imgUrl + ')'}}>
                    <div className="Bar">
                        <Link className="MainLogoFix" to={backId}></Link>
                        <h2 className="hidden-sm hidden-xs">{this.props.value.title}</h2>
                        <Link className="CloseButtonX" to={backId} onClick={this.handleClose}><span>X</span></Link>
                    </div>
                    <div className="Inner" ref={(innerDiv) => this._innerDiv = innerDiv}>
                        <div className="row">
                            <div className="col-md-4 col-xs-12">
                                <div ref={(btn) => {
                                    this.toggleBtn = btn;
                                }} className="toggleNav visible-sm-inline-block visible-xs-inline-block">
                                    <button className={"toggleNavBtn " + (this.state.navVisible ? "hide" : "")}
                                            onClick={this.toggleNav}><i
                                        className="material-icons">keyboard_arrow_down</i>{this.props.value.title}
                                    </button>
                                    <button
                                        className={"Button-Active toggleNavBtn " + (!this.state.navVisible ? "hide" : "")}
                                        onClick={this.toggleNav}><i
                                        className="material-icons">keyboard_arrow_up</i>{this.props.value.title}
                                    </button>
                                </div>

                                <div className={"NavContainer " + (this.state.navVisible ? "navVisible" : "navHidden")}
                                     ref={(topDiv) => this._top = topDiv}>
                                    <div
                                        className={"NavButtons " + (this.state.navVisible ? "navVisible" : "navHidden")}>
                                        {navButtons}
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-8 col-xs-12 element" id="overlay-content"
                                 ref={(content) => this._content = content}>
                                <div className="Panel-Scrollable">
                                    {images.length > 0 &&
                                    <Slideshow images={images}/>
                                    }



                                    {bookingUrl !== "" && [
                                        <div className="CallbackContainer">
                                            <Callback site={"https://landhotel-schorssow.de"} url={callbackUrl}/>
                                            <div style={{clear: "both"}}></div>
                                        </div>,
                                        <Link to="/buchen" className="ButtonRight BuchenTop">Jetzt Zimmer buchen</Link>
                                        ]
                                    }


                                    <h3>{headline}</h3>
                                    <p dangerouslySetInnerHTML={{__html: text}}></p>


                                    {showAusstattung && expPanels && expPanels[0] &&
                                    <div>
                                        <ExpandableText idx={0} expanded={textExpanded} headline={expPanels[0].headline}
                                                        text_short={expPanels[0].text_short} text={expPanels[0].text}/>
                                    </div>
                                    }
                                    {showInfos && expPanels && expPanels[1] &&
                                    <div>
                                        <ExpandableText idx={1} expanded={textExpanded} headline={expPanels[1].headline}
                                                        text_short={expPanels[1].text_short} text={expPanels[1].text}/>
                                    </div>
                                    }

                                    {showHinweise && expPanels && expPanels[2] &&
                                    <div>
                                        <ExpandableText idx={2} expanded={textExpanded} headline={expPanels[2].headline}
                                                        text_short={expPanels[2].text_short} text={expPanels[2].text}/>
                                    </div>
                                    }

                                    {bookingUrl !== "" &&
                                    <Link to="/buchen" className="ButtonRight">Jetzt Zimmer buchen</Link>
                                    }

                                </div>
                                <div className="mobileToTop" onClick={this.toTop}><a><i
                                    className="material-icons">vertical_align_top</i> Nach oben</a></div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        );
    }
}

export default Overlay;



// WEBPACK FOOTER //
// ./src/components/Overlay/Overlay.js